import type { FormLocale } from '@jlg-website/shared';
import { Check } from '@/components/pages/icons';
import { textFor } from './copy';

type ConfirmButtonProps = {
  locale: FormLocale;
  disabled: boolean;
  onClick: () => void;
};

/** "Confirm my call back" — the action that books, in either flow. */
export function ConfirmButton({ locale, disabled, onClick }: ConfirmButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="brand-button w-full bg-brand-primary py-3.5 text-sm text-white disabled:cursor-not-allowed disabled:opacity-70"
    >
      <Check className="size-4" />
      {textFor(locale, 'confirmAction')}
    </button>
  );
}
